(function () {
  var badge = null;
  var gallery = null;
  var ticking = false;

  function updatePosition() {
    if (!badge || !gallery) return;
    var rect = gallery.getBoundingClientRect();
    // Hide badge when gallery is out of viewport
    if (rect.top < -badge.offsetHeight || rect.bottom < 0) {
      badge.style.display = 'none';
    } else {
      badge.style.display = 'block';
      badge.style.top = (rect.top - 17) + 'px';
      badge.style.left = (rect.right - 100) + 'px';
    }
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(updatePosition);
      ticking = true;
    }
  }

  function init() {
    badge = document.getElementById('pdp-discount-badge');
    gallery = document.querySelector('product-gallery');
    if (!badge || !gallery) return;

    if (badge.parentElement !== document.body) document.body.appendChild(badge);
    badge.style.position = 'fixed';
    badge.style.zIndex = '9';
    badge.style.pointerEvents = 'none';

    updatePosition();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', updatePosition);
  }

  document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('load', updatePosition);
})();
